module.exports = __webpack_public_path__ + "img/2023-01-09a_3.34cf8ea1.jpg";